import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class PersonsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${PersonsService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/persons';

    public getPersons(): Observable<any> {
        return this.http.get<any>(PersonsService.URL);
    }
}
